import angular from "angular";
import toastr from 'toastr';

angular.module('tags')

    .controller("tagsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $filter, $state, logService) {

            $rootScope.title = $filter('translate')('tags.title');
            logService.debug($filter('translate')('tags.title'));
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tags.title') }
            ];

            $scope.allowWrite = LoginService.permissionExist("FILES_WRITE");

            $scope.gridOptions = {
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'title', displayName: $filter('translate')('general.title'), enableFiltering: true, enableHiding: false, maxWidth: 250 },
                    { name: 'description', displayName: $filter('translate')('general.description'), enableFiltering: true, enableHiding: false },
                    {
                        name: 'entity_type', displayName: $filter('translate')('tags.entity_type'), enableFiltering: true, enableHiding: false,
                        cellTemplate: gridService.entityTypeTemplate('entity_type'),
                    },
                    { name: 'color', displayName: $filter('translate')('general.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 50 },
                    {
                        name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                            '</div>', width: 80, enableFiltering: false, enableHiding: false
                    },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_edit'), action: 'ui-sref="tags.edit({id:row.entity.id,entity_type: null,entity_id: null})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.title);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('Tags').getList(options)
                }
            };


            $scope.goToEdit = function (rowEntity) {
                $state.go("tags.edit", { id: rowEntity.id, entity_type: null, entity_id: null });
            };

            $scope.deleteDialog = function (id, title) {

                modalService.confirm({
                    title: $filter('translate')('tags.button_delete'),
                    message: $filter('translate')('tags.delete_message'),
                    onAccept: function () {
                        Restangular.one('Tags', id).remove().then(function () {
                            toastr.success($filter('translate')('tags.deleted_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });


            }

        }])